import Button from "@/ui/Button.tsx";
import {useTranslation} from "react-i18next";
import eventEmitter from "@/utils/event_emmiter_instance.ts";
import CommonClass from "@/utils/common.ts";
import WarningCircleIcon from "@/svg/WarningCircleIcon.tsx";
import st from "@/styles/DocReader.module.scss"
import CameraWarns from "@/ui/CameraWarns.tsx";
import {useEffect} from "react";
import useAuth from "@/hooks/auth.ts";
import {isMobile} from "react-device-detect";
import clsx from "clsx";
import KYCInstructions from "@/components/kyc_scenario_elements/KycInstructions.tsx";
import {getCookie, setCookie24h} from "@/utils/cookies.ts";


interface Props {
    message?:string
    hide_button?:boolean
}


const ResetDocReader:React.FC<Props> = (props) => {

    const {
        message,
        hide_button,
    } = props

    const {t} = useTranslation()
    const auth = useAuth()
    
    useEffect(() => {
        const ping = async () => {
            auth.auth_ping()
        }
        
        ping()

        return () => {
            setCookie24h("got_scan_error", "true");
        }
    }, []);

    const error = !getCookie("got_scan_error") ? t('error_message_scan_doc') : message;

    return (
        <div className={clsx(st.reset_doc_reader, isMobile && st.mobile)}>
            
            <div className={st.inf}>
                <WarningCircleIcon />
    
                <strong>
                    {error}
                </strong>
            </div>
            
            {!hide_button && (
                <Button
                    className={st.reset_button}
                    onClick={() => {
                        eventEmitter.emit(CommonClass.CustomEvents.switch_doc_reader, "")
                    }}
                >
                    {t("reset")}
                </Button>
            )}


            <CameraWarns cam_bad_quality />
            
            <KYCInstructions />
        </div>
    )
}

export default ResetDocReader